import React from 'react';
import styled from 'styled-components';

function Burger() {
  return (
    <div className="burger">
      <StyledWrapper>
        <input type="checkbox" id="checkbox" />
        <label htmlFor="checkbox" className="toggle">
          <div className="bar bar--top" />
          <div className="bar bar--middle" />
          <div className="bar bar--bottom" />
        </label>
        <div className="menu slide-in-right-transition">
        <img src="/neonlogo.png" alt="Price level" style={{ width: '170px', position: 'absolute', top: '95px' }} />
          <a href="/">PROFILE</a>
          <a href="/about">ABOUT</a>
          <a href="/game">GAME</a>
          <div style={{position: 'fixed', width: '200px', bottom: '50px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          {/* <a style={{fontSize: '11px', marginLeft: '15px'}} href="https://climify.com/terms-conditions">TERMS OF SERVICE</a> 
          <a style={{fontSize: '11px'}} href="https://climify.com/privacy-policy">PRIVACY POLICY</a> */}
          </div>
        </div>
      </StyledWrapper>
    </div>
  );
}

const StyledWrapper = styled.div`
  #checkbox {
    display: none;
  }

  /* Posiziona la toggle in modo fisso con z-index superiore */
  .toggle {
    position: fixed;
    right: 46px;
    width: 25px;
    cursor: pointer;
    z-index: 1000001;
    height: 24px;
    margin-top: -12px;
  }

  .bar {
    position: absolute;
    left: 0;
    right: 0;
    height: 2px;
    border-radius: 2px;
    background: #eef6ff;
    opacity: 1;
    transition: 0.35s cubic-bezier(0.5, -0.35, 0.35, 1.5);
  }

  /* Animazione Spin */
  .bar--top {
    bottom: calc(50% + 7px + 2px);
    transition-property: bottom, transform;
    transition-delay: 0.35s, 0s;
  }

  .bar--middle {
    top: calc(50% - 1px);
    transition-property: opacity;
    transition-delay: 0.35s;
  }

  .bar--bottom {
    top: calc(50% + 7px + 2px);
    transition-property: top, transform;
    transition-delay: 0.35s, 0s;
  }

  #checkbox:checked + .toggle .bar--top {
    bottom: calc(50% - 2px);
    transform: rotate(135deg);
    transition-delay: 0s, 0.35s;
  }

  #checkbox:checked + .toggle .bar--middle {
    opacity: 0;
    transition-duration: 0s;
    transition-delay: 0.35s;
  }

  #checkbox:checked + .toggle .bar--bottom {
    top: calc(50% - 2px);
    transform: rotate(225deg);
    transition-delay: 0s, 0.35s;
  }

  /* Menu a schermo intero */
  .menu {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #e4299c;
    z-index: 1000000;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  /* Mostra il menu quando il checkbox è checked */
  #checkbox:checked ~ .menu {
    display: flex;
  }

  .menu a {
    margin: 10px 0;
    font-size: 24px;
    color: #eef6ff;
    text-decoration: none;
  }
`;

export default Burger;
